module.exports.globals = {
    casesPerPage: 10,
    dentistsPerPage: 20,
    patientsPerPage: 30,
    historyPerPage: 10,
    adminPatientsPerPage:10,
    reportsPerPage: 15,
    numberOfMessages: 20,
    maxNumberBookedZirconia:18,
    bridgesTopConnect:12,
    bridgesBottomConnect:42,
    bridgesTopRightLast:28,
    bridgesTopLeftLast:18,
    bridgesTopCenterLeft:11,
    bridgesTopCenterRight:21,
    bridgesBottomCenterRight:31,
    bridgesBottomCenterLeft:41,
    warningCountOfMisc:5,
    warningCountOfZirc:5,
    SUNDAY_INDEX:0,
    SATURDAY_INDEX:6,
    BOOKING_TYPES: {
        PROTOTYPE: 'prototype',
        ZIRCONIA: 'zirconia',
        CERAMIC: 'ceramic',
        TEMP: 'temp',
        OTHER: 'other',
    },
    CASE_TYPE: {
        PROTOTYPE: 'Prototype',
        ZIRCONIA: 'Zirconia',
        CERAMIC: 'Ceramic',
        TEMP: 'Temp',
        OTHER: 'Other',
    },
    PATIENT: {
        STATUS: {
            READY: 'ready',
            CANCEL: 'cancel',
            ON_HOLD: 'onhold',
            OVERDUE: 'overdue',
            PENDING: 'pending',
            RECEIVED: 'received',
            REJECTED: 'rejected',
            SCHEDULED: 'scheduled',
            RESCHEDULED: 'rescheduled',
            ARCHIVED: 'archived',
        }
    },
    RESERVED_DAYS_TYPES: {
        VACATION: 'vacation',
        LAB_CLOSED: 'lab_closed'
    },
    NUMBER_OF_UNITS_ZIRCONIA: 18,
    NUMBER_OF_UNITS_MISC: 16,
    NAV_BIG: 991,
    NAV_MIDDLE:600,
    JOBS: {
        OVERDUESTATUS: 'overduestatus',
        REMINDERFORMARK: 'reminderformark',
        NOTIFICATIONSCLEAR: 'notificationsclear',
        SYNCES:'synces',
    }
}



//////////////////
// WEBPACK FOOTER
// ../common/constants.js
// module id = 29
// module chunks = 0